<template>
    <CCard class="page mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol class="d-flex justify-content-end">
                    <ButtonBack class="mr-3" title="Go back" />
                </CCol>
            </CRow>
        </CCardHeader>
        
        <CCardBody>
            <CTabs variant="tabs" :active-tab="0">
                <!--  Tab General -->
                <CTab :title="$t('general')"> 
                    <FieldGeneralTab :field="forms.viewField" v-if="forms.viewField" :mode="viewType" :loading.sync="forms.viewField._loading"  />
                </CTab>
                <CTab :title="$t('uses')" :disabled="!uuid">
                    <FieldUsesTab :field="forms.viewField" v-if="forms.viewField.uuid" :mode="viewType" :loading.sync="forms.viewField._loading" />
                </CTab>
                <CTab :title="$t('options')" :disabled="!uuid || forms.viewField.type != 'options'">
                    <FieldOptionsTab :field="forms.viewField" v-if="forms.viewField.uuid" :mode="viewType" :loading.sync="forms.viewField._loading" />
                </CTab>
            </CTabs>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import ButtonBack from "£lement/ButtonBack";
import FieldGeneralTab from "~/pages/Admin/Headers/Components/FieldGeneralTab.vue";
import FieldOptionsTab from "~/pages/Admin/Headers/Components/FieldOptionsTab.vue";
import FieldUsesTab from "~/pages/Admin/Headers/Components/FieldUsesTab.vue";


import SubTagTab from "~/pages/Admin/Headers/Components/SubTagTab.vue";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import { validationMixin } from "vuelidate";
import formMixin from "~/mixins/form";

/** Others */
import { cilTrash, cilArrowBottom, cilArrowTop, cilPlus } from "@coreui/icons";

export default {
    name: "FieldViewPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, formMixin, validationMixin],

    icons: {
        cilTrash,
        cilArrowTop,
        cilArrowBottom,
        cilPlus,
    },

    data(){
        return {
            forms: {
                viewField: {
                    uuid: null,
                    name: null,
                    code: null,
                    tagUuid: null,
                    uses: null,
                    type: null,
                    isCustom: null,
                    options: null,
                    fieldOptions:null,
                    _loading: false,
                    _matchResponse: "_items",
                },
            },
        }
    },

    components: {
        ButtonBack,
        FieldGeneralTab,
        FieldOptionsTab,
        FieldUsesTab,
        SubTagTab
    },
    computed: {
        viewType: function () {
            return this.routeName.includes("edit") ? "edit" : "create";
        },
        uuid: function () {
            return this.$route.query.uuid;
        },
    },
    watch:{
        "forms.viewField._loading": function (val) {
            this.updatePageLoading(val);
        },
    },
    async mounted() {
        if (this.viewType == "edit") {
            await this.updateForm({
                formName: "viewField",
                url: "fields/" + this.uuid,
                fetch: {
                    baseURL: process.env.VUE_APP_API_CORE,
                },
                adapterData: (data) => {
                    if (data.tag && data.tag.uuid) {
                        data = {
                            ...data,
                            tagUuid: data.tag.uuid,
                        };
                    }
                    return data;
                },
            });
        }
        this.updatePageLoading(false);
    },
};
</script>

<style lang="scss" scoped>
.input-fields {
    margin-bottom: 1rem;
}
</style>
